import React from "react";
import { useSelector } from "react-redux";

function AdditionalDetails() {
  const editField = useSelector((state) => state.shipment.ui.clone.editField);

  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
        Additional details
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-33 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Product ID
          </span>
          <div>{editField?.productId?.value}</div>
        </div>
        <div className="w-33 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Product Serial Number
          </span>
          <div>{editField?.productSerialNumber?.value}</div>
        </div>
        <div className="w-33 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Tracking Number
          </span>
          <div>{editField?.trackingNumber?.value}</div>
        </div>
      </div>
      <div className="py-2 w-100 d-flex flex-row justify-content-start align-items-center">
        <div className="w-33 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Order Number
          </span>
          <div>{editField?.orderNumber?.value}</div>
        </div>
        <div className="w-33 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            Customer Name
          </span>
          <div>{editField?.customerName?.value}</div>
        </div>
        <div className="w-33 d-flex flex-column justify-content-center align-items-start">
          <span className="d-flex flex-row justify-content-start align-items-center font-face-vzw shipment-clone-font-size">
            PO Number
          </span>
          <div>{editField?.poNumber?.value}</div>
        </div>
      </div>
    </>
  );
}

export default AdditionalDetails;
